import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getInvertColor } from "utils/themeUtils";
import { ReactComponent as LightBulb } from "./light-bulb.svg";

interface Props {
	color?: string;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
	root: {
		"& .a": {
			fill: getInvertColor(theme.palette.primary.main),
		},
	},
}));

export const LightBulbIcon = ({ color }: Props) => {
	const classes = useStyles({ color });
	return <LightBulb className={classes.root} />;
};
